enum OrderSellerRemarksFlag {
    BLUE = "BLUE",

    NONE = "NONE",

    GREEN = "GREEN",

    PURPLE = "PURPLE",

    RED = "RED",

    YELLOW = "YELLOW",

    /** 以下是淘宝特有的旗帜 */
    ORANGE = "ORANGE",

    "LIGHT_BLUE" = "LIGHT_BLUE",

    PINK = "PINK",

    "DARK_GREEN" = "DARK_GREEN",

    PEACH = "PEACH",
}

export default OrderSellerRemarksFlag;
